<template>
    <Page :is-loading="isPageLoading" :page-code="pageCode" @reload="loadPage">
        <div class="page-body">
            <Panel>
                <span slot="title">
                    <i class="iconfont icon-doctoral-cap fs20px top2px" /> {{orderDetail.name}}
                </span>
                <div class="lh2em bottom-line">{{orderDetail.description}}</div>
                <div class="mb-1rem">
                    <Goods v-for="(goods, i) in orderDetail.goods" :goods="goods" :key="i" />
                    <StudentOrderPayment :student="orderDetail.student" :payment="orderDetail.payment" />
                </div>
            </Panel>
            <Panel>
                <span slot="title">
                    <i class="iconfont icon-heart-plus fs20px top2px" /> 编程课服务号
                </span>
                <div class="mide-qr-code lh1_8em flex-column flex-x-center flex-y-center">
                    <p>查看编程课课表</p>
                    <p>获取编程课内容、编程作品及作业</p>
                    <a href="/images/mide-qr-code.jpg">
                        <img class="qr-code" src="/images/mide-qr-code.jpg">
                    </a>
                    <p v-if="isWxBrowser">请长按二维码前往公众号并关注</p>
                    <p v-else>微信扫描二维码前往公众号并关注</p>
                    <p>米德编程服务中心</p>
                </div>
            </Panel>
            <Help link="/user-doc/交费详情/index.html">
                <span v-if="isWxBrowser">长按二维码前往公众号并关注</span>
                <span v-else>微信扫描二维码前往公众号并关注</span>
            </Help>
        </div>
    </Page>
</template>

<script>
    import Page from '@/components/Page.vue';
    import Panel from '@/components/Panel.vue';
    import Help from '@/components/Help.vue';
    import Goods from '@/pages/fee/components/Goods.vue';
    import StudentOrderPayment from '@/pages/fee/components/StudentOrderPayment.vue';
    import PageLoading from '@/mixins/PageLoading';
    import WxPreparing from '@/mixins/WxPreparing';

    export default {
        name: 'OrderMasterDetail',
        components: {
            Page, Panel, Help, Goods, StudentOrderPayment,
        },
        mixins: [PageLoading, WxPreparing],
        data() {
            return {
                orderDetail: {},
            };
        },
        async mounted() {
            await this.loadPage();
            await this.hideWxAllMenuItems();
        },
        methods: {
            async loadPageData() {
                const { orderMasterUuid } = this.$route.params;
                const { studentUuid } = this.$route.query;
                const res = await this.$api.orderMaster.orderDetails(orderMasterUuid, studentUuid);
                this.orderDetail = res.data.data;
            },
        },
    };
</script>

<style scoped lang="less">
    .qr-code {
        width: 38vw;
        display: block;
        margin: 5px 0;
    }
</style>
